/* eslint-disable no-param-reassign */
import Fetch, { V1, serializeQueryString } from 'Util/fetcher';

const ON_REQUEST_PORTFOLIO_BONUS = 'ON_REQUEST_PORTFOLIO_BONUS';
const ON_REQUEST_PORTFOLIO_BONUS_FAILURE = 'ON_REQUEST_PORTFOLIO_BONUS_FAILURE';
const ON_REQUEST_PORTFOLIO_BONUS_SUCCESS = 'ON_REQUEST_PORTFOLIO_BONUS_SUCCESS';
const ON_REQUEST_PORTFOLIO_BONUS_DETAIL = 'ON_REQUEST_PORTFOLIO_BONUS_DETAIL';
const ON_REQUEST_PORTFOLIO_BONUS_DETAIL_FAILURE = 'ON_REQUEST_PORTFOLIO_BONUS_DETAIL_FAILURE';
const ON_REQUEST_PORTFOLIO_BONUS_DETAIL_SUCCESS = 'ON_REQUEST_PORTFOLIO_BONUS_DETAIL_SUCCESS';
const ON_REQUEST_SELL_BONUS_STOCK = 'ON_REQUEST_SELL_BONUS_STOCK';
const ON_REQUEST_SELL_BONUS_STOCK_FAILURE = 'ON_REQUEST_SELL_BONUS_STOCK_FAILURE';
const ON_REQUEST_SELL_BONUS_STOCK_SUCCESS = 'ON_REQUEST_SELL_BONUS_STOCK_SUCCESS';
const ON_REQUEST_HISTORY_BONUS_STOCK = 'ON_REQUEST_HISTORY_BONUS_STOCK';
const ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE = 'ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE';
const ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS = 'ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS';
const ON_REQUEST_ORDER_BONUS_STOCK = 'ON_REQUEST_ORDER_BONUS_STOCK';
const ON_REQUEST_ORDER_BONUS_STOCK_FAILURE = 'ON_REQUEST_ORDER_BONUS_STOCK_FAILURE';
const ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS = 'ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS';
const ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL = 'ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL';
const ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_SUCCESS = 'ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_SUCCESS';
const ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_FAILURE = 'ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_FAILURE';
const ON_REQUEST_CANCEL_BONUS_STOCK = 'ON_REQUEST_CANCEL_BONUS_STOCK';
const ON_REQUEST_CANCEL_BONUS_STOCK_FAILURE = 'ON_REQUEST_CANCEL_BONUS_STOCK_FAILURE';
const ON_REQUEST_CANCEL_BONUS_STOCK_SUCCESS = 'ON_REQUEST_CANCEL_BONUS_STOCK_SUCCESS';
const ON_REQUEST_AMEND_BONUS_STOCK = 'ON_REQUEST_AMEND_BONUS_STOCK';
const ON_REQUEST_AMEND_BONUS_STOCK_FAILURE = 'ON_REQUEST_AMEND_BONUS_STOCK_FAILURE';
const ON_REQUEST_AMEND_BONUS_STOCK_SUCCESS = 'ON_REQUEST_AMEND_BONUS_STOCK_SUCCESS';

function onRequestPortfolioBonus(resetData) {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS,
    meta: { resetData },
  };
}

function onRequestPortfolioBonusSuccess(payload, resetData) {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS_SUCCESS,
    payload,
    meta: { resetData },
  };
}

function onRequestPortfolioBonusFailure(payload) {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS_FAILURE,
    payload,
  };
}

export const onDoRequestGetPortfolioBonus = (payload, resetData) => (dispatch) => {
    dispatch(onRequestPortfolioBonus(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/bonus/portfolio/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestPortfolioBonusSuccess(resp.json, resetData));
        } else {
          dispatch(onRequestPortfolioBonusFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestPortfolioBonusFailure(error.message));
      });
  };

function onRequestPortfolioBonusDetail() {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS_DETAIL,
  };
}

function onRequestPortfolioBonusDetailSuccess(payload) {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS_DETAIL_SUCCESS,
    payload,
  };
}

function onRequestPortfolioBonusDetailFailure(payload) {
  return {
    type: ON_REQUEST_PORTFOLIO_BONUS_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestGetPortfolioBonusDetail = payload => (dispatch) => {
  dispatch(onRequestPortfolioBonusDetail());
  Fetch.get(`${V1}stock/bonus/portfolio/detail/?code=${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestPortfolioBonusDetailSuccess(resp.json));
      } else {
        dispatch(onRequestPortfolioBonusDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestPortfolioBonusDetailFailure(error.message));
    });
};

function onRequestHistoryBonusStock(resetData) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK,
    meta: { resetData },
  };
}

function onRequestHistoryBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestHistoryBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestGetHistoryBonusStock = (payload, resetData) => (dispatch) => {
    dispatch(onRequestHistoryBonusStock(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/bonus/sell/matched/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestHistoryBonusStockSuccess(resp.json));
        } else {
          dispatch(onRequestHistoryBonusStockFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestHistoryBonusStockFailure(error.message));
      });
  };

function onRequestOrderBonusStock(resetData) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK,
    meta: { resetData },
  };
}

function onRequestOrderBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestOrderBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestGetOrderBonusStock = (payload, resetData) => (dispatch) => {
    dispatch(onRequestOrderBonusStock(resetData));
    const qs = serializeQueryString(payload);
    Fetch.get(`${V1}stock/bonus/sell/${qs}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestOrderBonusStockSuccess(resp.json));
        } else {
          dispatch(onRequestOrderBonusStockFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestOrderBonusStockFailure(error.message));
      });
  };

function onRequestSellBonusStock() {
  return {
    type: ON_REQUEST_SELL_BONUS_STOCK,
  };
}

function onRequestSellBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_SELL_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestSellBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_SELL_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestSellBonusStock = payload => (dispatch) => {
  dispatch(onRequestSellBonusStock());
  Fetch.post(`${V1}stock/bonus/sell/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestSellBonusStockSuccess(resp.json));
      } else {
        dispatch(onRequestSellBonusStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestSellBonusStockFailure(error.message));
    });
};

function onRequestCancelBonusStock() {
  return {
    type: ON_REQUEST_CANCEL_BONUS_STOCK,
  };
}

function onRequestCancelBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_CANCEL_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestCancelBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_CANCEL_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestCancelBonusStock = payload => (dispatch) => {
  dispatch(onRequestCancelBonusStock());
  Fetch.delete(`${V1}stock/bonus/sell/cancel/${payload}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestCancelBonusStockSuccess(resp.json));
      } else {
        dispatch(onRequestCancelBonusStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestCancelBonusStockFailure(error.message));
    });
};

function onRequestAmendBonusStock() {
  return {
    type: ON_REQUEST_AMEND_BONUS_STOCK,
  };
}

function onRequestAmendBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_AMEND_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestAmendBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_AMEND_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestAmendBonusStock = (payload, pay) => (dispatch) => {
  dispatch(onRequestAmendBonusStock());
  Fetch.put(`${V1}stock/bonus/sell/amend/${payload}/`, pay)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestAmendBonusStockSuccess(resp.json));
      } else {
        dispatch(onRequestAmendBonusStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestAmendBonusStockFailure(error.message));
    });
};

function onRequestTransStockBonusDetail() {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL,
  };
}

function onRequestTransBonusDetailSuccess(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_SUCCESS,
    payload,
  };
}

function onRequestTransBonusDetailFailure(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestTransStockBonusDetail = payload => (dispatch) => {
  dispatch(onRequestTransStockBonusDetail());
  Fetch.get(`${V1}stock/bonus/sell/detail/${payload}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestTransBonusDetailSuccess(resp.json));
      } else {
        dispatch(onRequestTransBonusDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTransBonusDetailFailure(error.message));
    });
};

const INITIAL_STATE = {
  portfolioBonusLoading: false,
  portfolioBonusData: null,
  portfolioBonusError: null,
  portfolioBonusDetailLoading: false,
  portfolioBonusDetailData: null,
  portfolioBonusDetailError: null,
  sellBonusStock: false,
  sellBonusStockSuccess: null,
  sellBonusStockFailure: null,
  historyBonusData: null,
  historyBonusLoading: false,
  historyBonusError: null,
  orderBonusData: null,
  orderBonusLoading: false,
  orderBonusError: null,
  bonusStockPlayLoading: false,
  bonusStockPlayData: null,
  bonusStockPlayError: null,
  transDetailBonusLoading: false,
  transDetailBonusData: null,
  transDetailBonusError: null,
  cancelBonusStock: false,
  cancelBonusStockSuccess: null,
  cancelBonusStockFailure: null,
  amendBonusStock: false,
  amendBonusStockSuccess: null,
  amendBonusStockFailure: null,
};

const freeStock = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_PORTFOLIO_BONUS:
      return {
        ...state,
        portfolioBonusLoading: true,
        portfolioBonusError: null,
        portfolioBonusData: state.portfolioBonusData,
      };
    case ON_REQUEST_PORTFOLIO_BONUS_SUCCESS:
      if (state.portfolioBonusData !== null && !action.meta.resetData) {
        state.portfolioBonusData = {
          count: action.payload.count,
          results: [
            ...state.portfolioBonusData.results,
            ...action.payload.results,
          ],
        };
      } else {
        state.portfolioBonusData = action.payload;
      }
      return {
        ...state,
        portfolioBonusLoading: false,
        portfolioBonusError: null,
      };
    case ON_REQUEST_PORTFOLIO_BONUS_FAILURE:
      return {
        ...state,
        portfolioBonusLoading: false,
        portfolioBonusError: action.payload,
      };
    case ON_REQUEST_PORTFOLIO_BONUS_DETAIL:
      return {
        ...state,
        portfolioBonusDetailLoading: true,
        portfolioBonusDetailData: null,
        portfolioBonusDetailError: null,
      };
    case ON_REQUEST_PORTFOLIO_BONUS_DETAIL_SUCCESS:
      return {
        ...state,
        portfolioBonusDetailLoading: false,
        portfolioBonusDetailData: action.payload,
        portfolioBonusDetailError: null,
      };
    case ON_REQUEST_PORTFOLIO_BONUS_DETAIL_FAILURE:
      return {
        ...state,
        portfolioBonusDetailLoading: false,
        portfolioBonusDetailData: null,
        portfolioBonusDetailError: action.payload,
      };
    case ON_REQUEST_SELL_BONUS_STOCK:
      return {
        ...state,
        sellBonusStock: true,
        sellBonusStockFailure: null,
        sellBonusStockSuccess: null,
      };
    case ON_REQUEST_SELL_BONUS_STOCK_SUCCESS:
      return {
        ...state,
        sellBonusStock: false,
        sellBonusStockFailure: null,
        sellBonusStockSuccess: action.payload,
      };
    case ON_REQUEST_SELL_BONUS_STOCK_FAILURE:
      return {
        ...state,
        sellBonusStock: false,
        sellBonusStockFailure: action.payload,
        sellBonusStockSuccess: null,
      };
    case ON_REQUEST_CANCEL_BONUS_STOCK:
      return {
        ...state,
        cancelBonusStock: true,
        cancelBonusStockFailure: null,
        cancelBonusStockSuccess: null,
      };
    case ON_REQUEST_CANCEL_BONUS_STOCK_SUCCESS:
      return {
        ...state,
        cancelBonusStock: false,
        cancelBonusStockFailure: null,
        cancelBonusStockSuccess: action.payload,
      };
    case ON_REQUEST_CANCEL_BONUS_STOCK_FAILURE:
      return {
        ...state,
        cancelBonusStock: false,
        cancelBonusStockFailure: action.payload,
        cancelBonusStockSuccess: null,
      };
    case ON_REQUEST_AMEND_BONUS_STOCK:
      return {
        ...state,
        amendBonusStock: true,
        amendBonusStockFailure: null,
        amendBonusStockSuccess: null,
      };
    case ON_REQUEST_AMEND_BONUS_STOCK_SUCCESS:
      return {
        ...state,
        amendBonusStock: false,
        amendBonusStockFailure: null,
        amendBonusStockSuccess: action.payload,
      };
    case ON_REQUEST_AMEND_BONUS_STOCK_FAILURE:
      return {
        ...state,
        amendBonusStock: false,
        amendBonusStockFailure: action.payload,
        amendBonusStockSuccess: null,
      };
    case ON_REQUEST_HISTORY_BONUS_STOCK:
      if (action.meta.resetData) {
        state.historyBonusData = null;
      }
      return {
        ...state,
        historyBonusLoading: true,
        historyBonusError: null,
      };
    case ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS:
      if (state.historyBonusData !== null) {
        state.historyBonusData = {
          count: action.payload.count,
          results: [
            ...state.historyBonusData.results,
            ...action.payload.results,
          ],
        };
      } else {
        state.historyBonusData = action.payload;
      }
      return {
        ...state,
        historyBonusLoading: false,
        historyBonusError: null,
      };
    case ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE:
      return {
        ...state,
        historyBonusLoading: false,
        historyBonusError: action.payload,
      };
    case ON_REQUEST_ORDER_BONUS_STOCK:
      if (action.meta.resetData) {
        state.orderBonusData = null;
        state.amendBonusStockSuccess = null;
        state.cancelBonusStockSuccess = null;
      }
      return {
        ...state,
        orderBonusLoading: true,
        orderBonusError: null,
      };
    case ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS:
      if (state.orderBonusData !== null) {
        state.orderBonusData = {
          count: action.payload.count,
          results: [...state.orderBonusData.results, ...action.payload.results],
        };
      } else {
        state.orderBonusData = action.payload;
      }
      return {
        ...state,
        orderBonusLoading: false,
        orderBonusError: null,
      };
    case ON_REQUEST_ORDER_BONUS_STOCK_FAILURE:
      return {
        ...state,
        orderBonusLoading: false,
        orderBonusError: action.payload,
      };
    case ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL:
      return {
        ...state,
        transDetailBonusLoading: true,
        transDetailBonusData: null,
        transDetailBonusError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_SUCCESS:
      return {
        ...state,
        transDetailBonusLoading: false,
        transDetailBonusData: action.payload,
        transDetailBonusError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_BONUS_DETAIL_FAILURE:
      return {
        ...state,
        transDetailBonusLoading: false,
        transDetailBonusData: null,
        transDetailBonusError: action.payload,
      };
    default:
      return state;
  }
};

export default freeStock;
